import type { OnboardingAnswers, OnboardingData } from '~/types/onboarding';

export type PreferencesIdentifyTraitsPayload = {
  status: string | null;
  industry_id: string | null;
  company_size: string | null;
  customer_group_id: string | null;
  job_position_id: string | null;
  country_code: string | null;
  application_ids: string[];
  buying_journey_phase: string | null;
};

export type PreferencesIdentifyTraits = {
  preferences: PreferencesIdentifyTraitsPayload;
};

/**
 * Maps Magento-backed customer preference answers into Ninetailed identify traits.
 * Always returns a full `preferences` object so cleared fields overwrite prior values.
 */
export function buildPreferencesIdentifyTraits(
  answers: OnboardingAnswers,
  onboardingData: OnboardingData | null | undefined
): PreferencesIdentifyTraits {
  return {
    preferences: {
      status: onboardingData?.cp_onboarding_status ?? null,
      industry_id: answers.industryId,
      company_size: answers.companySizeId,
      customer_group_id: answers.customerGroupId,
      job_position_id: answers.jobPositionId,
      country_code: onboardingData?.cp_country_code ?? null,
      application_ids: [...answers.applicationIds],
      buying_journey_phase: answers.buyingJourneyPhase
    }
  };
}
